module.exports = __webpack_public_path__ + "img/日落海岸线.467fbc07.jpg";